/**
 * File expertsLeads.js.
 *
 * Expert leads for Our Work section.
 */
( function() {
	// State variables
	let isSearching = false;
	// Function to match Brunswick's region by timezone
	//https://gist.github.com/diogocapela/12c6617fc87607d11fd62d2a4f42b02a
	function getRegionFromTimezone(timezone) {
		//console.log("timezone: " + timezone);
		if (!timezone || typeof timezone !== 'string') return 'Unknown';
		if (timezone.startsWith('America/')) {
			return 'Americas';
		}
		if (timezone.startsWith('GMT+0') || 
			timezone.startsWith('GMT-0') ||
			timezone.startsWith('GMT0') ||
			timezone.startsWith('GMT') ||
			timezone.startsWith('Greenwich') ||
			timezone.startsWith('GB')
		){
			return 'London';
		}
		if (timezone.startsWith('Europe/')) {
			switch (timezone) {
				case 'Europe/Berlin':
					return 'Berlin';
					break;
				case 'Europe/Brussels':
					return 'Brussels';
					break;
				case 'Europe/Lisbon':
					return 'Lisbon';
					break;
				case 'Europe/London':
					return 'London';
					break;
				case 'Europe/Belfast':
					return 'London';
					break;
				case 'Europe/Isle_of_Man':
					return 'London';
					break;
				case 'Europe/Madrid':
					return 'Madrid';
					break;
				case 'Europe/Rome':
					return 'Milan';
					break;
				case 'Europe/Paris':
					return 'Paris';
					break;
				case 'Europe/Stockholm':
					return 'Stockholm';
					break;
				default:
					return 'Europe';
				break;
			}
		}
		if (
			timezone === 'Asia/Qatar' ||
			timezone === 'Asia/Kuwait' ||
			timezone === 'Asia/Bahrain' ||
			timezone === 'Asia/Muscat' ||
			timezone === 'Asia/Baghdad' ||
			timezone === 'Asia/Tehran' ||
			timezone === 'Asia/Jerusalem' ||
			timezone === 'Asia/Tel_Aviv' ||
			timezone === 'Asia/Amman'
		) {
			return 'IMEA';
		}
		if (timezone.startsWith('Asia/')) {
			switch (timezone) {
				case 'Asia/Shanghai':
					return 'Shanghai';
					break;
				case 'Asia/Riyadh':
					return 'Riyadh';
					break;
				case 'Asia/Dubai':
					return 'Dubai';
					break;
				case 'Asia/Tokyo':
					return 'Tokyo';
					break;
				case 'Asia/Singapore':
					return 'Singapore';
					break;
				case 'Asia/Hong_Kong':
					return 'Hong Kong';
					break;
				case 'Asia/Calcutta':
					return 'Mumbai';
					break;
				default:
					return 'Asia-Pacific';
				break;
			}
		}
		if (timezone.startsWith('Australia/')) {
			return 'Sydney';
		}
		if (
			timezone.startsWith('Pacific/') ||
			timezone.startsWith('Antarctica/Macquarie')
		) {
			return 'Asia-Pacific';
		}
		if (timezone.startsWith('Africa/')) {
			switch (timezone) {
				case 'Africa/Johannesburg':
					return 'Johannesburg';
					break;
				case 'Africa/Cairo':
					return 'IMEA';
					break;
				default:
					return 'Unknown';
				break;
			}
		}

		if (
			timezone.startsWith('Indian/') ||
			timezone.startsWith('Etc/GMT')
		) {
			return 'IMEA';
		}

		return 'Unknown';
	}
	//Set user region
	const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	const region = getRegionFromTimezone(timezone);
	/*************************************
	 * AJAX SEARCH FUNCTIONALITY
	 *************************************/
	const getExpertLeads = function(target,targetPanel) {
		let taxonomy = jQuery('.our-work-tabs button.active').attr('data-taxonomy');
		let termId = target.getAttribute('data-term-id');
		let data = {
			action: 'expertsAjaxEvents',
			request: 'getExpertsLeadsByTaxonomy',
			taxonomy: taxonomy,
			term_id: termId,
			region: region,
		};
		jQuery.ajax({
			url: BrunswickL10n.ajax_url,
			data: data,
			success: function(response) {
				if(response.data.markup !==''){
					let leadsElement = targetPanel.querySelector('.accordion__row-leads .cards');
					leadsElement.innerHTML = response.data.markup;
					//Update count class
					const substr = 'count-';
					[...leadsElement.classList]
						.filter(c => c.includes(substr))
						.forEach(c => leadsElement.classList.remove(c));
					const experts = leadsElement.querySelectorAll('.expert');
					leadsElement.classList.add(`count-${experts.length}`);
				}
			},
			complete: function() {
				window.revealElements();
			}
		});
	};
	// Callback function from accordion
	window.accordionCallback = function(target,targetPanel) {
		//Only trigger fetching of expert leads once
		if(!target.classList.contains('leads_fetched')){
			target.classList.add('leads_fetched');
			getExpertLeads(target,targetPanel);
		}
	}
}() );
